import { ApiClientsContext } from "../../../customHooks/useApiClients/context.js";
import { useInitApiClients } from "../../../customHooks/useApiClients/index.js";

export const WithApiClientsProvider = ({ children }: { children: React.ReactNode }) => {
    const state = useInitApiClients();

    return <ApiClientsContext.Provider value={state}>{state.clients.length === 0 ? null : children}</ApiClientsContext.Provider>;
};
